import { render, staticRenderFns } from "./mdModalSignPatientGuardian.vue?vue&type=template&id=a651d5be&"
import script from "./mdModalSignPatientGuardian.vue?vue&type=script&lang=js&"
export * from "./mdModalSignPatientGuardian.vue?vue&type=script&lang=js&"
import style0 from "./mdModalSignPatientGuardian.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports